import { useMemo } from 'react'

import { getConfiguration } from 'services/config'

export const useCountry = () =>
  useMemo(() => getConfiguration().countryCode, [])
